import React, { useState } from 'react'
import styles from './index.module.scss'

export type Props = {
  currentIndex?: number
  children: any
  tabs: any[]
  context?: any
  onChangeIndex?: any
}

export function Tabs({ onChangeIndex, children, context, currentIndex = 0, tabs }: Props) {
  const [currIndex, setIndex] = useState(currentIndex)
  const setTab = (index) => {
    onChangeIndex && onChangeIndex(index)
    setIndex(index)
  }

  if (!children) return null

  const currentChild = React.Children.toArray(children)[currIndex]

  if (React.isValidElement(currentChild)) {
    return (
      <div className={styles.container}>
        <ul className={styles.tabContainer}>
          {context}
          {tabs?.map((tab, index) => (
            <button
              key={index}
              className={index === currIndex ? styles.tabActive : ''}
              type="button"
              onClick={() => setTab(index)}
            >
              {tab}
            </button>
          ))}
        </ul>
        <div>{React.cloneElement(currentChild)}</div>
      </div>
    )
    // return React.cloneElement(currentChild)
  }

  return (
    <div className={styles.container}>
      <ul>
        {tabs?.map((tab, index) => (
          <button key={index} type="button" onClick={() => setIndex(index)}>
            {tab}
            {currIndex}
          </button>
        ))}
      </ul>
      <div>{currentChild}</div>
    </div>
  )
}
